import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { isEmpty } from "lodash";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
// import PromotionDetail from "../component/PromotionDetail";
import Layout from "./Layout";
import PromotionDetail from "../components/PromotionDetail";

const Promotion = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [show, setShow] = useState({});

  const profileData = useContextSelector(AuthContext, (ctx) => ctx.profileData);
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);

  // ---- same "already claimed first/second/third/fourth deposit offer" filter as the old page ----
  const getFilteredOfferList = (count, list) => {
    const depositKeysToRemove = [
      "OnFirstDeposit",
      "OnSecondDeposit",
      "OnThirdDeposit",
      "OneFourthDeposit",
    ];
    const keysToRemove = depositKeysToRemove.slice(0, count);
    return list.filter((offer) => !keysToRemove.includes(offer.offerOn));
  };

  const getData = async () => {
    const { status, data } = await apiGet(apiPath.getPromotional);
    if (status == 200 && data?.success) {
      let updated = getFilteredOfferList(
        profileData?.userDepositCount,
        data?.results?.offerList || [],
      );
      setData(updated);
    }
  };

  useEffect(() => {
    getData();
  }, [profileData]);

  // ---- same "End in X days Y hours" / "Ended" logic as the old page, matching the new design's "End in 476 D 8 H" wording ----
  const getEndLabel = (endTime) => {
    if (!endTime) return "";
    const now = moment();
    const end = moment(endTime);
    if (end.isBefore(now)) return t("Ended");
    const duration = moment.duration(end.diff(now));
    const days = Math.floor(duration.asDays());
    const hours = duration.hours();
    return t("EndInDaysHours", { days, hours });
  };

  return (
    <Layout>
      <div className="promotion-container">
        <div className="v-image v-responsive hidden-sm-and-down white--text align-end pa-0 theme--light">
          <div
            className="v-responsive__sizer"
            style={{ "padding-bottom": "24.4444%" }}
          />
          <div
            className="v-image__image v-image__image--preload v-image__image--cover"
            style={{ "background-position": "center center" }}
          />
          <div className="v-responsive__content">
            <div className="v-card__title promotion-banner-text font-weight-bold">
              <p className="ml-3">
                <span className="text-capitalize">{t("Promotion")}</span>
              </p>
            </div>
          </div>
        </div>

        <div className="row promotion-wrapper my-5">
          {data?.map((res) => (
            <div key={res?._id} no-gutters className="col-md-6 col-lg-6 col-12">
              <div className="promotion-card v-card v-sheet theme--light">
                <div className="v-image v-responsive theme--light">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "37.0748%" }}
                  />
                  <div
                    className="v-image__image v-image__image--cover"
                    style={{
                      "background-image": `url("${process.env.REACT_APP_API_BASE_URL}${res?.descriptionImage}")`,
                      "background-position": "center center",
                    }}
                  />
                  <div className="v-responsive__content" />
                </div>
                <div className="row promotion-desc-container no-gutters">
                  <div className="promotion-desc-deco hidden-sm-and-down" />
                  <div className="promotion-desc-title-container col col-12">
                    <div className="mb-1 font-weight-bold">{res?.title}</div>
                    <div className="promotion-end-date hidden-sm-and-down">
                      {getEndLabel(res?.offerEndDateTime)}
                    </div>
                  </div>
                  <div className="promotion-desc-box col col-12">
                    <div className="mb-1 d-block text-truncate">
                      {res?.shortDescription || res?.description || res?.title}
                    </div>
                  </div>
                  <div className="promotion-button-container col">
                    {!isEmpty(user) && (
                      <button
                        type="button"
                        onClick={() => navigate(`/deposit/${res?._id}`)}
                        className="button-primary promotion-button caption font-weight-bold"
                      >
                        {t("ApplyNow")}
                      </button>
                    )}
                    <button
                      type="button"
                      onClick={() => setShow(res)}
                      className="button-primary promotion-button caption font-weight-bold"
                    >
                      {t("Details")}
                    </button>
                    <span className="caption d-flex align-center justify-center">
                      <i
                        aria-hidden="true"
                        className="v-icon notranslate promotion-time-icon material-icons theme--light"
                        style={{ "font-size": "14px" }}
                      >
                        access_time
                      </i>
                      {getEndLabel(res?.offerEndDateTime)}{" "}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}

          {isEmpty(data) && (
            <div className="col-12 text-center py-5 white--text">
              {t("NoPromotions")}
            </div>
          )}

          {/**/}
        </div>
        <div
          data-v-9cead1be
          role="dialog"
          className="v-dialog__container"
          scrollable="true"
        >
          {/**/}
        </div>
      </div>

      {!isEmpty(show) && <PromotionDetail show={show} setShow={setShow} />}
    </Layout>
  );
};

export default Promotion;








